import { memo, FC } from 'react';
import cn from 'classnames';
import Text, {
  TextColors,
  TextPresets,
} from '@stripcash/ui-kit/components/Text';
import Button, { ButtonColor } from '@stripcash/ui-kit/components/Button';
import LoadIcon from '@stripcash/ui-kit/icons/load.svg';
import NoSignalIcon from '@stripcash/ui-kit/icons/noSignal.svg';

import { Translate } from 'common/i18n/types';

import styles from './styles.module.css';

type OfflinePageProps = {
  onRetryClick: () => void;
  offlineTranslation: Translate;
  isMobile: boolean;
};

const OfflinePage: FC<OfflinePageProps> = memo(
  ({ onRetryClick, offlineTranslation, isMobile }) => (
    <div className={styles.wrapper}>
      <div className={cn(styles.rectangle, styles.rectangleSecondPadding)}>
        <div className={cn(styles.rectangle, styles.rectangleSecondPadding)}>
          <div className={styles.rectangle}>
            <NoSignalIcon size={isMobile ? 24 : 48} />
          </div>
        </div>
      </div>
      <div className={styles.infoWrapper}>
        <Text preset={TextPresets.H2}>{offlineTranslation('title')}</Text>
        <div className={styles.descriptionWrapper}>
          <Text preset={TextPresets.Body14} color={TextColors.Gray}>
            {offlineTranslation('description')}
          </Text>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            color={ButtonColor.Default}
            onClick={onRetryClick}
            iconStart={<LoadIcon />}
          >
            Retry
          </Button>
        </div>
      </div>
    </div>
  ),
);

export default OfflinePage;
